import script from "./ElementDescription.vue?vue&type=script&lang=js"
export * from "./ElementDescription.vue?vue&type=script&lang=js"

import "./ElementDescription.vue?vue&type=style&index=0&id=09c9307f&lang=scss"

const __exports__ = script;

export default __exports__